import Image from "next/image";
import React from "react";
import clsx from "clsx";

import greenCheck from "./green-check.svg";
import sparkle from "./sparkle.svg";
import sparkleBlue from "./sparkleBlue.svg";

interface Props {
  height?: number;
  width?: number;
  icon: string;
  className?: string;
}

const icons = {
  sparkle,
  greenCheck,
  sparkleBlue,
};

const CustomIcon: React.FC<Props> = ({
  height = 16, width = 16, icon, className,
}) => {
  if (!icons[icon]) return <></>;

  return (
    <div className="flex items-center justify-center shrink-0">
      <Image className={clsx("m-auto", className || "")} height={height} width={width} src={icons[icon]} alt="sparkle" />
    </div>
  );
};

export default CustomIcon;
